import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return response
}

const linkUnlinkMerchantWithDeviceReq = (mid: string, deviceSerialNo: string, action: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.linkUnlinkMerchantWithDevice),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      deviceRequestList: [
        {
          mid: mid,
          deviceSerialNo: deviceSerialNo,
          action: action,
        },
      ],
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { linkUnlinkMerchantWithDeviceReq }
